import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        sand: {
          50: { value: "#F3F3F2" },
          100: { value: "#DDDDDC" },
          200: { value: "#C8C8C6" },
          300: { value: "#B2B2B1" },
          400: { value: "#9D9D9B" },
          500: { value: "#878785" },
          600: { value: "#71716F" },
          700: { value: "#5C5C59" },
          800: { value: "#373736" },
          900: { value: "#20201F" },
          950: { value: "#080807" },
        },
        night: {
          50: { value: "#F1F1F4" },
          100: { value: "#DADADD" },
          200: { value: "#C2C2C5" },
          300: { value: "#ABABAE" },
          400: { value: "#939396" },
          500: { value: "#7C7C7F" },
          600: { value: "#656567" },
          700: { value: "#4D4D4F" },
          800: { value: "#363638" },
          900: { value: "#17181d" },
          950: { value: "#070709" },
        },
      },
    },
    semanticTokens: {
      colors: {
        night: {
          fg: { value: "{colors.night.50}" },
          solid: { value: "{colors.night.100}" },
          contrast: { value: "{colors.night.900}" },
          muted: { value: "{colors.night.700}" },
          subtle: { value: "{colors.night.900}" },
          emphasized: { value: "{colors.night.300}" },
          focusRing: { value: "{colors.night.300}" },
        },
        sand: {
          fg: { value: "{colors.sand.50}" },
          solid: { value: "{colors.sand.100}" },
          contrast: { value: "{colors.sand.900}" },
          muted: { value: "{colors.sand.700}" },
          subtle: { value: "{colors.sand.900}" },
          emphasized: { value: "{colors.sand.300}" },
          focusRing: { value: "{colors.sand.300}" },
        },
        leadership: {
          fg: { value: "#44337A" },
          solid: { value: "#44337A" },
          contrast: { value: "#ffffff" },
          muted: { value: "#44337A" },
          subtle: { value: "{#44337A/10}" },
          emphasized: { value: "{colors.purple.emphasized}" },
          focusRing: { value: "{colors.purple.focusRing}" },
        },
        tactics: {
          fg: { value: "#822727" },
          solid: { value: "#822727" },
          contrast: { value: "#ffffff" },
          muted: { value: "#822727" },
          subtle: { value: "{#822727/10}" },
          emphasized: { value: "{colors.red.emphasized}" },
          focusRing: { value: "{colors.red.focusRing}" },
        },
        spirit: {
          fg: { value: "#0A6E83" },
          solid: { value: "#0A6E83" },
          contrast: { value: "#ffffff" },
          muted: { value: "#0A6E83" },
          subtle: { value: "{#0A6E83/10}" },
          emphasized: { value: "{colors.teal.emphasized}" },
          focusRing: { value: "{colors.teal.focusRing}" },
        },
        lore: {
          fg: { value: "#21543D" },
          solid: { value: "#21543D" },
          contrast: { value: "#ffffff" },
          muted: { value: "#21543D" },
          subtle: { value: "{#21543D/10}" },
          emphasized: { value: "{colors.green.emphasized}" },
          focusRing: { value: "{colors.green.focusRing}" },
        },
        fellowship: {
          fg: { value: "#7B341E" },
          solid: { value: "#7B341E" },
          contrast: { value: "#ffffff" },
          muted: { value: "#7B341E" },
          subtle: { value: "{#7B341E/10}" },
          emphasized: { value: "{colors.orange.emphasized}" },
          focusRing: { value: "{colors.orange.focusRing}" },
        },
        baggins: {
          fg: { value: "#744110" },
          solid: { value: "#744110" },
          contrast: { value: "#ffffff" },
          muted: { value: "#744110" },
          subtle: { value: "{#744110/10}" },
          emphasized: { value: "{colors.orange.emphasized}" },
          focusRing: { value: "{colors.orange.focusRing}" },
        },
        neutral: {
          fg: { value: "#363638" },
          solid: { value: "#363638" },
          contrast: { value: "#ffffff" },
          muted: { value: "#363638" },
          subtle: { value: "{#363638/10}" },
          emphasized: { value: "{colors.gray.emphasized}" },
          focusRing: { value: "{colors.gray.focusRing}" },
        },
      },
    },
  },
  conditions: {
    container_sm: "@container (width >= 26rem)",
  },
});

export default createSystem(defaultConfig, config);
